<!--
 * @Author: 陆伟
 * @Date: 2019-11-14 11:08:52
 * @LastEditors: chenzel
 * @LastEditTime: 2021-06-09 11:18:01
 * @Description: 
 -->
<template>
  <div class="search-view top-bar " :class="{ hideGoBackBtn: isApp && hideGoBackBtn == 'true','inapp': isApp}">
    <div class="search-back-btn back-btn iconfont icon-left-arrow" v-if="appCont!==7" @click="lastPage"></div>
    <form class="search-form" @click="toSearchPage">
      <i class="search-icon"></i>
      <input type="search" :placeholder="searchDefaultValue" disabled>
    </form>
    <div class="search-right" v-if="isApp" @click="tapShare">
      <img class="share-img" v-if="isShowShareImg" src="https://static.yunjiglobal.com/qnUpload/frontend/rank_share_red.png" alt="">
      <Icon name="share" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
// eslint-disable-next-line import/extensions
import { Icon } from '@yunji/h5'
import YunJi from '@/assets/js/YunJi'

const { mapState, mapActions } = createNamespacedHelpers('categoryNav')

export default {
  components: {
    Icon
  },
  props: ['pageId'],
  data() {
    return {
      appCont: parseInt(YunJi.getUrlParams('appCont'), 10),
      shopId: YunJi.getUrlParams('shopId'),
      isShowShareImg: false,
      hideGoBackBtn: YunJi.getUrlParams('hideGoBackBtn')
    }
  },
  computed: {
    ...mapState({
      isApp: state => state.isApp,
      categoryType: state => state.categoryType,
      searchDefaultValue: state => state.searchDefaultValue, // 搜索框默认显示值
      searchType: state => state.searchType
    }),
    isNewGoosTab() {
      return this.categoryId === this.newGoodsTabId
    }
  },
  created() {
    this.judgeShowShareImg()
    this.querySearchPage()
    this.querySearchType()
    if (this.isApp) {
      window.setJsToHiddenProfit = this.setJsToHiddenProfit.bind(this)
    }
  },
  methods: {
    ...mapActions(['querySearchPage', 'querySearchType']),
    tapShare() {
      const { origin, pathname } = window.location
      const tUrl = `${origin}${pathname}?categoryType=${this.categoryType}&appCont=0&shopId=${this.shopId}`

      // 设置为今天已经点击过了
      window.localStorage.setItem('isTodayShow', true)
      const currentTime = new Date().getTime()
      window.localStorage.setItem('currentTime', currentTime)
      this.isShowShareImg = false

      const params = {
        url: tUrl,
        shareTitle: '云集分类页',
        shareContent: '全网爆款，尽在云集'
      }
      YunJi.callApp('jsCallNativeShowCategoryShare', JSON.stringify(params), {
        fail: () => {
          window.location.href = `yunji://common/shareToWxOrLink?url=${tUrl}&shareTitle=${encodeURIComponent('云集分类页')}&shareContent=${encodeURIComponent('全网爆款，尽在云集')}`
        }
      })
      // this.$root.$emit('showShareSheet')
    },
    // 判断是否展示分享左上角的浮窗图标
    judgeShowShareImg() {
      const isTodayShow = window.localStorage.getItem('isTodayShow')
      const currentTime = Number(window.localStorage.getItem('currentTime'))
      if (currentTime) {
        if (new Date(currentTime).toDateString() === new Date().toDateString() && isTodayShow) {
          this.isShowShareImg = false
        } else if (new Date(currentTime) < new Date()) {
          this.isShowShareImg = true
          window.localStorage.setItem('isTodayShow', false)
        }
      } else {
        window.localStorage.setItem('isTodayShow', false)
        this.isShowShareImg = true
      }
    },
    toSearchPage() {
      window.thinkingReport.track('others', {
        page_id: this.pageId,
        point_id: '21625',
        operation_name: 'btn_搜索'
      })
      let url = ''
      if (this.isApp) {
        window.location.href = `yunji://common/searchList?value=${this.searchDefaultValue}&newChannelId=${this.searchType}`
      } else {
        const params = {
          appCont: this.appCont,
          newChannelId: this.searchType,
          isCategory: '1',
          index: this.searchDefaultValue === '搜索商品' ? '' : '0', // 有搜索底纹，就传底纹index去搜索页面。
          shopId: this.shopId
        }
        // eslint-disable-next-line no-return-assign
        const expStr = Object.keys(params).reduce((o, k) => o += `&${k}=${encodeURIComponent(params[k])}`, '')
        url = `//${window.globalConfig.buyerBasePath}/yjbuyer/search-list?${expStr.substr(1)}`
        window.location.href = url
      }
    },
    lastPage() {
      if (this.isApp) {
        window.location.href = 'yunji://common/goBack'
      } else {
        // eslint-disable-next-line no-restricted-globals
        history.back()
      }
    },
    setJsToHiddenProfit(res) { // app告诉h5是否隐藏利润，1隐藏，0显示 林枫(向林)
      this.$store.commit('categoryNav/SET_IS_SHARING', res === '1')
      this.$nextTick(() => {
        YunJi.callApp('jsCallNativeHiddenProfitState', res)
        this.$forceUpdate()
      })
    }
  }
  
}
</script>

<style lang="less" scoped>
@import '../../../style/common.less';
.search-view{
  padding-right: 0.32rem;
  &.inapp{
    padding-right: 0;
  }
  .search-form{
    display: flex;
    flex: 1;
    align-items: center;
    height: 0.6rem;
    padding-right: 0.5rem;
    border-radius: 0.32rem;
    background-color: #f6f6f6;
    color: #242528; 
    .search-icon{
      flex-basis: 0.7rem;
      width: 0.7rem;
      height: 100%;
      background-size: 0.3rem 0.32rem;
      background-position-y: center;
      background-position-x: 60%;
      background-repeat: no-repeat;
      background-image: url('../img/icon-search.png');
    }
    input{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &::-webkit-input-placeholder{
        color: #C0C0C5;
      }
    }
  }
  .search-right{
    position: relative;
    width: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .36rem;
    .share-img {
      position: absolute;
      z-index: 9;
      width: 0.48rem;
      height: 0.28rem;
      top: -0.1rem;
      left: 0;
    }
  }
  &.hideGoBackBtn{
    padding-left: 0.32rem;
    .search-back-btn{
      display: none;
    }
  }
}
</style>
